import React from 'react';
import { Radio } from 'antd';
import { tabsType } from 'types/pricingSimulator';

interface TabSwitchComponentProps {
    activeTabKey?: string;
    onTabChange: (tab: tabsType) => void;
    tabs: null | tabsType[];
}

const TabSwitchComponent: React.FC<TabSwitchComponentProps> = ({ onTabChange, activeTabKey, tabs }) => {
    return (
        <div>
            <Radio.Group defaultValue={activeTabKey ?? ''} className="flex">
                {tabs?.map((t: any, index: number) => {
                    return (
                        <Radio.Button
                            key={t.key}
                            value={t.key}
                            onChange={() => onTabChange(t)}
                            disabled={t.disabled}
                            className={`${index === 0 ? '!rounded-l-md' : ''} ${
                                index === tabs.length - 1 ? '!rounded-r-md' : ''
                            } border border-gray-300 px-4 py-2`}
                        >
                            {t.label}
                        </Radio.Button>
                    );
                })}
            </Radio.Group>
        </div>
    );
};

export default TabSwitchComponent;
